import React from 'react';
import {
  Alert,
  Box,
  Chip,
  List,
  ListItem,
  ListItemText,
  Stack,
  Typography,
} from '@mui/material';

const EnvironmentImportPrevalidation = ({ result }) => {
  if (!result) return null;

  return (
    <Stack spacing={2}>
      <Box>
        <Typography variant="h6" gutterBottom>Prévalidation locale</Typography>
        <Typography variant="body2" color="text.secondary">
          Contrôle de cohérence du fichier uniquement. Si cette étape est valide, tu pourras choisir les providers cibles puis lancer le pré-check serveur.
        </Typography>
      </Box>

      <Stack direction="row" spacing={1}>
        <Chip
          label={`${result.errors.length} erreur(s) bloquante(s)`}
          color={result.errors.length ? 'error' : 'success'}
          variant={result.errors.length ? 'filled' : 'outlined'}
        />
        <Chip
          label={`${result.warnings.length} avertissement(s)`}
          color={result.warnings.length ? 'warning' : 'default'}
          variant="outlined"
        />
      </Stack>

      {result.valid ? (
        <Alert severity="success">
          Le snapshot est cohérent. Tu peux maintenant configurer les providers cibles et lancer le pré-check serveur.
        </Alert>
      ) : (
        <Alert severity="error">
          Le snapshot contient des incohérences qui doivent être corrigées avant tout import.
        </Alert>
      )}

      {result.issues.length > 0 && (
        <List dense disablePadding>
          {result.issues.slice(0, 50).map((issue, index) => (
            <ListItem key={`${issue.type}-${index}`} disableGutters alignItems="flex-start">
              <ListItemText
                primary={issue.message}
                secondary={issue.type}
                primaryTypographyProps={{
                  color: issue.severity === 'error' ? 'error.main' : 'warning.main',
                }}
              />
            </ListItem>
          ))}
          {result.issues.length > 50 && (
            <ListItem disableGutters>
              <ListItemText secondary={`… ${result.issues.length - 50} contrôle(s) supplémentaire(s) non affiché(s).`} />
            </ListItem>
          )}
        </List>
      )}
    </Stack>
  );
};

export default EnvironmentImportPrevalidation;
